import { render, staticRenderFns } from "./ArticleContentModal.vue?vue&type=template&id=510bca4a&"
import script from "./ArticleContentModal.vue?vue&type=script&lang=js&"
export * from "./ArticleContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports